module.exports = __webpack_public_path__ + "img/34e118382efb705e6f1a5a2853441609.png";